export default __webpack_public_path__ + "static/SoehneBuch-5d935e347e5cad2b8d7de28ea6708c0c.woff2";